import { NavItem } from 'carehub-shared/nav-item';

export class BusinessModuleDetails {
  name: string;
  id: number;
  menuItems: Array<NavItem | null>;
}
